import { Cushion, MaxWidth } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import ActivityStream from '../../activity-stream';
import RosBottomBanner from '../../adverts/ros-bottom-banner';
import TopBannerVideoPlayerSwitch from '../../adverts/top-banner-video-player-switch';
import PageDataLoadError from '../../errors/page-data-load-error';
import NativeShelf from '../../native-adverts/shelf';
import NoResults from './no-results';
import SeasonFilter from '../season-filter';
import CLUB_PROP_TYPES from '../../../lib/prop-types/club';
import LOADING_ERROR_PROP_TYPES from '../../../lib/prop-types/loading-error';
import { SEASONS_PROP_TYPES } from '../../../lib/prop-types/season';
import useBreakpoint from '../../../lib/use-breakpoint';
import MobileSubHeader from '../mobile-sub-header';

const NUMBER_OF_ARTICLES_BEFORE_ADVERT = 12;

const MatchReports = ({
  isLoading,
  loadingError,
  club,
  reports,
  onSeasonFilterChange,
  seasons,
  seasonId,
}) => {
  if (loadingError) {
    return <PageDataLoadError clubId={club.id} {...loadingError} />;
  }

  const renderReportsBeforeAdvert = () => {
    if (!reports || reports.length < 1) {
      return null;
    }
    const slicedReports = reports.slice(0, NUMBER_OF_ARTICLES_BEFORE_ADVERT);

    return <ActivityStream isLoading={isLoading} messages={slicedReports} />;
  };

  const renderReportsAfterAdvert = () => {
    if (!reports || reports.length < NUMBER_OF_ARTICLES_BEFORE_ADVERT) {
      return null;
    }
    const slicedReports = reports.slice(NUMBER_OF_ARTICLES_BEFORE_ADVERT);

    return (
      <>
        <Cushion vertical="large">
          <RosBottomBanner />
        </Cushion>
        <ActivityStream isLoading={isLoading} messages={slicedReports} />
      </>
    );
  };

  const renderReports = () => {
    if (reports.length > 0 || isLoading) {
      return (
        <Cushion vertical="large">
          {renderReportsBeforeAdvert()}
          {renderReportsAfterAdvert()}
          <NativeShelf paddingProps={{ top: 'medium' }} />
        </Cushion>
      );
    }

    return (
      <>
        <NoResults />
        <Cushion vertical="large">
          <RosBottomBanner />
        </Cushion>
      </>
    );
  };

  const { advertisingTier, sportId } = club;
  const isMobile = useBreakpoint();

  return (
    <div>
      {seasons.length > 0 && (
        <>
          <Cushion bottom="medium">
            {isMobile && <MobileSubHeader title="Reports" transKey="teams:navigation_reports" />}
            <TopBannerVideoPlayerSwitch
              advertisingTier={advertisingTier}
              pageType="team.reports"
              sportId={sportId}
            />
          </Cushion>
          <MaxWidth component="div" maxWidth={1366} center>
            <SeasonFilter seasons={seasons} selected={seasonId} onChange={onSeasonFilterChange} />
          </MaxWidth>
        </>
      )}
      {renderReports()}
    </div>
  );
};

MatchReports.defaultProps = {
  loadingError: null,
};

MatchReports.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadingError: LOADING_ERROR_PROP_TYPES,
  club: CLUB_PROP_TYPES.isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onSeasonFilterChange: PropTypes.func.isRequired,
  seasons: SEASONS_PROP_TYPES.isRequired,
  seasonId: PropTypes.number.isRequired,
};

export default MatchReports;
